import { getBaseUrl } from '../../../utils/getBaseUrl';

export const WHERE_WE_FLY_URL = (currentAirport: string) => {
	const baseUrl = getBaseUrl();

	return `https://houston.wherewefly.com/?share=${encodeURIComponent(
		`${baseUrl}/${currentAirport}/explore-destinations`,
	)}/&amp;override=yes`;
};
